var map = {
	"./About/about.vue": 8064,
	"./About/describe.vue": 59,
	"./About/feedback.vue": 4185,
	"./About/team.vue": 7294,
	"./AdvanceSearch/advanceSearch.vue": 8570,
	"./Biographical/biographical.vue": 4149,
	"./DiscoveringRelationships/discoveringRelationships.vue": 6447,
	"./Footprints/footprints.vue": 2309,
	"./Home/home.vue": 4076,
	"./MentorshipRelations/mentorshipRelations.vue": 5101,
	"./Place/place.vue": 919,
	"./SocialRelations/socialRelations.vue": 6403,
	"./TimeGraph/timeGraph.vue": 7059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9464;